import type { IconSvgObject } from './types';

const PanelTopBottomDashedIcon: IconSvgObject = [
  ["path", { d: "M3 9H5M9 9H10M14 9H15M19 9H21M3 15H5M9 15H10M14 15H15M19 15H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 19V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default PanelTopBottomDashedIcon;
